import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import "./styles.css";
import { ErrorBoundary, Provider } from "@rollbar/react";
import { Toaster } from "sonner";
import { App } from "@/app.tsx";
import { AppProviders } from "@/lib/app-providers.tsx";
import { rollbar } from "@/lib/rollbar.ts";
import reportWebVitals from "./reportWebVitals.ts";

// Render the app
const rootElement = document.getElementById("app");
if (rootElement && !rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);

  root.render(
    <StrictMode>
      <Provider instance={rollbar}>
        <ErrorBoundary>
          <AppProviders>
            <App />
          </AppProviders>
          <Toaster />
        </ErrorBoundary>
      </Provider>
    </StrictMode>,
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
